import { Icon, IconsEnum } from 'components/Icons';
import { resetFiltersSelected } from 'features/sport/actions';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useAppDispatch } from 'lib/centralStore';
import styles from './SportNavFiltersHeader.module.scss';

export type SportNavFiltersHeaderProps = {
  label: string;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SportNavFiltersHeader = ({ label, handleClose }: SportNavFiltersHeaderProps) => {
  const dispatch = useAppDispatch();
  const labelResetFiltri = useGetLabelByKey('prematch-filters-reset');

  const handleClickReset = () => {
    dispatch(resetFiltersSelected());
  };

  return (
    <div className={styles.container}>
      <button type="button" className={styles.button} onClick={() => handleClose(false)}>
        <Icon iconId={IconsEnum.ARROW} className={styles.icon} color={'var(--color-primary)'} />
      </button>

      <span className={styles.text}>{label}</span>

      <button type="button" className={styles.resetBtn} onClick={() => handleClickReset()}>
        {labelResetFiltri}
      </button>
    </div>
  );
};
